<template>
    <div class="">
        <join-request
                name="Group"
                v-if="canJoin"
                :is-request-pending="viewer_state.is_join_request_pending"
                :request-pending-message="requestPendingMessage"
                @join="onJoinAttempt"
        ></join-request>
        <story-list
                v-if="!group.is_private"
                :story-resource="GroupStoryResource"
                :target-id="targetId"
                :allow-add-content="false"
        >
            <div class="alert alert-info" slot="empty">There has been nothing added to this Group's story yet</div>
        </story-list>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {DjangoUrls} from 'DjangoUrls';
    import JoinRequest from "../../../../vue/common_components/JoinRequest";
    import {CurrentUserClass} from "shared/CurrentUser";
    import {mapGetters} from "vuex";
    import LoginOrRequestInvitePopup from "./LoginOrRequestInvitePopup";
    import simplePopupFactory from "shared/simple_popups/simplePopupFactory";
    import RequestInvitePopup from "./RequestInvitePopup";
    import GroupInviteResource from "../../groups/group_invite_resource";
    import GroupResource from "../../groups/group_resource";
    import LikeStoryResourceFactory from "shared/story/resource_factory";
    import StoryList from "shared/story/StoryList";

    const CurrentUser = new CurrentUserClass();

    const COOKIE_KEY = '';

    export default {
        name: "GroupPagePublicStory",
        components: {StoryList, JoinRequest},
        data() {
            return {};
        },
        computed: {
            ...mapGetters('groupPage', {viewer_state: 'viewer_state', group: 'group'}),
            $_cookieKey() {
                return `jrstg${this.group.id}`;
            },
            GroupStoryResource() {
                const $http = Vue.getAngularModule('$http');
                return LikeStoryResourceFactory('group_story')($http);
            },
            targetId() {
                return this.group.id;
            },
            canJoin() {
                return (!this.viewer_state.is_member) && (
                    !(CurrentUser.is_authenticated()) ||
                    CurrentUser.has_permission('join-groups')
                );
            },
            requestPendingMessage() {
                if (new CurrentUserClass().is_authenticated()) {
                    return 'Your request to join this group has been sent. You’ll be added as soon as an admin approves it. Please check back here or watch for an email notification.';
                }
                return '';
            },
        },
        methods: {
            $_sendJoinRequest() {
                const $rootScope = Vue.getAngularModule('$rootScope');
                const $http = Vue.getAngularModule('$http');
                $rootScope.show_dimmer();
                GroupResource($http).join(this.group.id)
                    .then(resp => {
                        let status = resp.data.status; // 'joined' or 'wait_confirmation'
                        if (status === 'joined') {
                            Vue.notifications.success('Joined');
                            this.$store.dispatch('groupPage/loadInfoAndViewerState');
                            // $rootScope.$broadcast('update_activity_counters');
                        }
                        if (status === 'wait_confirmation') {
                            this.$store.commit('groupPage/updateViewerState', {is_join_request_pending: true});
                            simplePopupFactory().show_popup('Join request sent.', 'You will join Group after approval. We will notify you.', 'OK');
                            $rootScope.hide_dimmer();
                        }
                    }, err => {
                        Vue.notifications.error(err || 'Error');
                        $rootScope.hide_dimmer();
                    });
            },
            $_sendInviteRequest(data) {
                const $rootScope = Vue.getAngularModule('$rootScope');
                const $http = Vue.getAngularModule('$http');
                const $cookies = Vue.getAngularModule('$cookies');
                $rootScope.show_dimmer();
                GroupInviteResource($http).request_invite(this.group.id, data)
                    .then(resp => {
                        Vue.notifications.success('Invite request successfully sent');
                        this.$store.commit('groupPage/updateViewerState', {is_join_request_pending: true});
                        const tomorrow = new Date();
                        tomorrow.setDate(tomorrow.getDate() + 1);
                        $cookies.put(this.$_cookieKey, 1, {expires: tomorrow});
                    }, err => {
                        Vue.notifications.error(err || 'Error');
                    })
                    .finally($rootScope.hide_dimmer);
            },
            $_showRequestInvitePopup() {
                const {vm, popupComponent, fEl} = simplePopupFactory().mount_vue_popup(RequestInvitePopup);
                popupComponent.show()
                    .then(({message, email}) => {
                        this.$_sendInviteRequest({message, email});

                    }, () => {
                    })
                    .finally(() => {
                        vm?.$destroy();
                        fEl?.focus();
                    });
            },
            $_goToLogInPage() {
                const $rootScope = Vue.getAngularModule('$rootScope');
                $rootScope.show_dimmer();
                document.location.href = DjangoUrls['auth_login']() + `?next=${document.location.pathname}`;
            },
            $_showLogInOrRequestInvitePopup() {
                const {vm, popupComponent, fEl} = simplePopupFactory().mount_vue_popup(LoginOrRequestInvitePopup);
                popupComponent.show()
                    .then(res => {
                        if (res === 'login') {
                            this.$_goToLogInPage();
                        } else if (res === 'request_invite') {
                            this.$_showRequestInvitePopup();
                        }
                    }, () => {
                    })
                    .finally(() => {
                        vm?.$destroy();
                        fEl?.focus();
                    });
            },
            onJoinAttempt() {
                if (CurrentUser.is_authenticated()) {
                    this.$_sendJoinRequest();
                } else {
                    this.$_showLogInOrRequestInvitePopup();
                }
            },
            $_checkCookiesForSentRequest() {
                const $cookies = Vue.getAngularModule('$cookies');
                if (!CurrentUser.is_authenticated() && parseInt($cookies.get(this.$_cookieKey)) === 1) {
                    console.log(this.$_cookieKey);
                    this.$store.commit('groupPage/updateViewerState', {is_join_request_pending: true});
                }
            },
        },
        mounted() {
            this.$_checkCookiesForSentRequest();
        }
    };
</script>
